import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import track, { useTracking } from 'react-tracking';
import TableSolid from '@simplywallst/ui-core/icons/TableSolid';
import { Button } from '@simplywallst/ui-core/next';
import RawDataModal from './RawDataModal';
import loadable from '@loadable/component';

const GuestRegistrationModal = loadable(
  () => import(/* webpackPrefetch: true */ '@components/GuestRegistrationModal')
);
interface RawDataProps {
  cyId?: string;
  title?: ReactNode;
  companyId: string;
  children?: ReactNode;
  shouldShowRegoModal: boolean;
}

const RawData = ({
  cyId,
  title,
  children,
  companyId,
  shouldShowRegoModal,
}: RawDataProps) => {
  const [openDataModal, setOpenDataModal] = useState(false);
  const [openRegoModal, setOpenRegoModal] = useState(false);
  const { trackEvent } = useTracking();

  useEffect(() => {
    closeRawDataModal();
  }, [companyId]);

  const openRawDataModal = () => {
    trackEvent({
      type: 'track',
      subject: 'inlineRegistration',
    });
    setOpenRegoModal(shouldShowRegoModal);
    setOpenDataModal(!shouldShowRegoModal);
  };

  const closeRawDataModal = () => {
    setOpenDataModal(false);
  };

  return (
    <>
      <Button
        data-cy-id={cyId || 'raw-data'}
        variant="outline"
        size="medium"
        onClick={openRawDataModal}
      >
        <TableSolid />
        Data
      </Button>
      {openDataModal && (
        <RawDataModal title={title} onClose={closeRawDataModal}>
          {children}
        </RawDataModal>
      )}
      {openRegoModal && (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            setOpenRegoModal(false);
            trackEvent({
              modifier: 'log_in_sign_up',
              action: 'close',
            });
          }}
          onRegisterSuccess={() => {
            setOpenRegoModal(false);
            trackEvent({
              modifier: 'registration',
              action: 'success',
            });
          }}
          onLoginSuccess={() => {
            setOpenRegoModal(false);
            trackEvent({
              modifier: 'login',
              action: 'success',
            });
          }}
        />
      )}
    </>
  );
};

export default track({ type: 'track' })(RawData);
